module.exports = __webpack_public_path__ + "static/media/004.3ea1667c.jpg";